// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--15n_I","image":"index-module--image--3hrda"};